// Pure updaters for the paged conversation lists (useInfiniteQuery data:
// { pages: [{ items, nextCursor }], pageParams }). Each cached list is keyed by
// its filters, so an update is applied to every list with filter awareness:
// a conversation only appears in lists whose filters it matches.

export function matchesFilters(conversation, filters = {}) {
  if (!conversation) return false
  const systems = conversation.systems ?? []
  if (filters.system && !systems.includes(filters.system)) return false
  if (filters.combined && systems.length < 2) return false
  if (filters.q && !String(conversation.title ?? '').toLowerCase().includes(String(filters.q).toLowerCase())) {
    return false
  }
  return true
}

export function flattenPages(data) {
  return data?.pages?.flatMap((page) => page.items) ?? []
}

export function findInPages(data, id) {
  return flattenPages(data).find((item) => item.id === id) ?? null
}

/** Insert (or move) a conversation to the top of the first page. */
export function upsertInPages(data, conversation, filters) {
  if (!data?.pages?.length) return data
  const pages = data.pages.map((page) => ({ ...page, items: page.items.filter((i) => i.id !== conversation.id) }))
  if (matchesFilters(conversation, filters)) {
    pages[0] = { ...pages[0], items: [conversation, ...pages[0].items] }
  }
  return { ...data, pages }
}

export function patchInPages(data, id, patch, filters) {
  if (!data?.pages) return data
  const pages = data.pages.map((page) => ({
    ...page,
    items: page.items
      .map((item) => (item.id === id ? { ...item, ...patch } : item))
      .filter((item) => item.id !== id || matchesFilters(item, filters)),
  }))
  return { ...data, pages }
}

export function removeFromPages(data, id) {
  if (!data?.pages) return data
  return { ...data, pages: data.pages.map((page) => ({ ...page, items: page.items.filter((i) => i.id !== id) })) }
}

/** Filters live at index 2 of ['conversations', 'list', filters]. */
export const filtersOfKey = (queryKey) => queryKey?.[2] ?? {}
